import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
@Component({
  selector: 'app-transportation-confirmation',
  templateUrl: './transportation-confirmation.component.html',
  styleUrls: ['./transportation-confirmation.component.scss']
})
export class TransportationConfirmationComponent implements OnInit {
  currentSchoolYear:string;
  programType:string;
  sentanceText:string='';
  constructor(
    private dialogRef: MatDialogRef<TransportationConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
     this.currentSchoolYear = this.data.schoolYear
     this.programType=this.data.programType.toUpperCase();
     if(this.data.requestType==='OPT-IN')
      {
        this.sentanceText=" for transportation for ";
     }
     else{
      this.sentanceText=" of transportation for ";
     }
  }

  closeDialog() {
    this.dialogRef.close();
  }
  confirmationBusTransportationSubmit() {
    this.dialogRef.close('submit');
  }
  
  getSchoolYear() {
    const now = new Date();
    const year = now.getFullYear();
    const isBeforeJuly = now.getMonth() < 6;

    const startYear = isBeforeJuly ? year - 1 : year;
    const endYear = startYear + 1;

    this.currentSchoolYear = `${startYear}${endYear}`;
  }

  formatTransportationSchoolYear(schoolYear: string): string {
  if (!schoolYear) {
    return 'N/A';
  }

  const year = schoolYear.toString();
  if (year.length === 8) {
    return `${year.substring(0, 4)}-${year.substring(4, 8)}`;
  }
  return year;
}

}

